import React from "react";
// import AddUser from "../screens/journal/Journal";
import JournalAddNote from "./journal/add-journal-note";

export default function Test() {
  return (
    <div>
      <JournalAddNote />
    </div>
  );
}
